<template>
  <div v-if="score !== null" class="quality-indicator" @click="toggleStats" :class="{ 'pulsing-border': showPulsingBorder }">
    <div class="signal-bars">
      <div class="bar" :class="{ active: score >= MosQuality.POOR }"></div>
      <div class="bar" :class="{ active: score >= MosQuality.FAIR }"></div>
      <div class="bar" :class="{ active: score >= MosQuality.GOOD }"></div>
      <div class="bar" :class="{ active: score >= MosQuality.EXCELLENT }"></div>
    </div>
  </div>
</template>

<script>
import { MosQuality } from 'webrtc-issue-detector'
export default {
  name: "QualityIndicator",
  data() {
    return {
      score: 1,
      stats: {},
      issues: [],
      showPulsingBorder: false,
      MosQuality,
    }
  },
  methods: {
    reset() {
      this.score = 1
      this.stats = {}
      this.issues = []
    },
    toggleStats() {
      const message = `
        <div style="font-family: monospace; white-space: pre-wrap; font-size: 11px;"><p>Score <br>${this.score.toFixed(2)}</p>
          <p>Stats <br>${JSON.stringify(this.stats, null, 2)}</p>
          <p>Issues <br>${JSON.stringify(this.issues, null, 2)}</p>
        </div>
      `

      this.$buefy.dialog.alert({
        title: 'Connection Stats',
        unsafeHtmlMessage: message,
        confirmText: 'Close',
        type: 'is-info',
        hasIcon: true,
        icon: 'chart-histogram',
        ariaRole: 'alertdialog'
      })
    }
  },
  watch: {
    issues: {
      handler(newIssues) {
        if (newIssues.length > 0 && this.showPulsingBorder === false) {
          this.showPulsingBorder = true;
          setTimeout(() => {
            this.showPulsingBorder = false;
          }, 10000);
        }
      },
      immediate: true
    }
  },
}
</script>

<style scoped lang="scss">
.quality-indicator {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 19;
  background: rgba(0, 0, 0, 0.5);
  padding: 5px;
  border-radius: 4px;
  border: 2px solid transparent;

  &.pulsing-border {
    animation: pulse-border 2.5s ease-in-out infinite;
  }

  .signal-bars {
    display: flex;
    align-items: flex-end;
    height: 15px;
    gap: 2px;

    .bar {
      width: 3px;
      background: rgba(255, 255, 255, 0.3);
      border-radius: 1px;

      &:nth-child(1) { height: 25%; }
      &:nth-child(2) { height: 50%; }
      &:nth-child(3) { height: 75%; }
      &:nth-child(4) { height: 100%; }

      &.active {
        background: #5aa2c0;
      }
    }
  }
}

@keyframes pulse-border {
  0% {
    border-color: rgba(255, 0, 0, 0.2);
  }
  50% {
    border-color: rgba(255, 0, 0, 0.6);
  }
  100% {
    border-color: rgba(255, 0, 0, 0.2);
  }
}
</style>